/**
 * Le cahier de charges d'une demande de soumission — chunk 9.AX.1.
 *
 * Une demande dit **à qui** et **quand** ; ce qu'elle demande vit ailleurs, dans
 * une réponse de formulaire structurée. Ces schémas décrivent le lien entre les
 * deux, et l'artefact PDF qui en découle.
 */

import { z } from "zod";

import { UuidSchema } from "./common.js";

/**
 * Body de `POST /v1/quote-requests/:id/spec`.
 *
 * `position` n'accepte que des entiers ≥ 1 : elle ordonne les scénarios le jour
 * où le moteur de formulaires saura les exprimer. Elle vaut 1 partout aujourd'hui.
 */
export const AttachQuoteRequestSpecSchema = z
  .object({
    form_response_id: UuidSchema,
    position: z.number().int().min(1).max(20).optional(),
  })
  .strict();
export type AttachQuoteRequestSpecInput = z.infer<typeof AttachQuoteRequestSpecSchema>;

/** Une ligne telle qu'elle revient au wire. Aucun identifiant d'auteur brut. */
export const QuoteRequestSpecSchema = z.object({
  id: UuidSchema,
  quote_request_id: UuidSchema,
  form_response_id: UuidSchema,
  /** Le PDF produit. `null` seulement si le rendu a échoué — jamais en régime normal. */
  artifact_file_id: UuidSchema.nullable(),
  position: z.number().int(),
  rendered_at: z.string().nullable(),
  created_at: z.string(),
});
export type QuoteRequestSpec = z.infer<typeof QuoteRequestSpecSchema>;
